module.exports = "<div *ngIf=\"meta.sType=='div'\" [innerHtml]=\"meta.content\">\n\n</div>\n<div *ngIf=\"meta.sType=='ajaxDiv'\">\n    <slide-ajax-div [url]=\"meta.contentUrl\"></slide-ajax-div>\n</div>\n<img [src]=\"meta.imgSrc\" *ngIf=\"meta.sType=='img'\" />"


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/carousel/slide/print-slide.component.html
// module id = ../../../../../src/app/content/libs/carousel/slide/print-slide.component.html
// module chunks = 1